import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-548cd258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserSucc" }
const _hoisted_2 = { style: {"align-items":"center","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"margin-left":"10px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import dayjs from 'dayjs'
import { downloadData, getListData } from '@/service/main/system'
import { ElNotification, ElMessage, ElLoading } from 'element-plus'
import useClipboard from 'vue-clipboard3'
import PageContent from '@/components/PageContent.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSucc',
  setup(__props) {

initEmptyParam()
const store = useStore()
const { toClipboard } = useClipboard()

const getChannelList = async () => {
  let channelData = await getListData(
    '/main/customerChannel/queryAllChannel',
    {}
  )
  const channelItem = searchFormConfig.formItems.find(
    (item) => item.field === 'sourceLabel'
  )
  channelItem!.options = channelData.map((item: any) => {
    return { title: item, value: item }
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData(
    '/main/customerChannel/queryThirdParty',
    {}
  )
  const thirdPartyItem = searchFormConfig.formItems.find(
    (item) => item.field === 'thirdParty'
  )
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return { title: item, value: item }
  })
}
getThirdPartyList()

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpName'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.name }
  })
}
getCompanyList()

const getGroupNameList = async () => {
  let groupData = await getListData('/main/userSucc/getGroupNameList', {})
  const groupItem = searchFormConfig.formItems.find(
    (item) => item.field === 'groupName'
  )
  groupItem!.options = groupData.map((item: any) => {
    return { title: item, value: item }
  })
}
getGroupNameList()

const queryParam = {
  succTime: [
    dayjs().startOf('month').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)

const copyValue = async (value: string) => {
  try {
    await toClipboard(value)
    ElNotification({
      title: '复制成功',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      type: 'error'
    })
  }
}

let loadingInstance = ref<InstanceType<typeof ElLoading>>()
const handleImportProgress = (res: any) => {
  loadingInstance = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

const handleImportSuccess = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance) {
    loadingInstance.close(); // 关闭Loading实例
  }
  // console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      duration: 0,
      showClose: true,
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if(res && res.code){
      ElMessage({
        type: 'warning',
        message: res.message
      })
    }else{
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick(queryParam)
    }
  }
}

const handleImportError = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance) {
    loadingInstance.close(); // 关闭Loading实例
  }
  // console.log(res)
  ElMessage({
    type: 'error',
    message: res.message
  })
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const handleDownloadImport = () => {
  const fileName = '成交客户导入模板.xlsx'
  downloadData(
    '/main/userSucc/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const resetCb = () => {
  return queryParam
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "userSucc",
      downFilename: "成交客户.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError,
      onYbwaveDownloadImport: handleDownloadImport,
      onSortChange: handleSortChange
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 30,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.name) + " (" + _toDisplayString(scope.row.remark) + ") ", 1)
        ])
      ]),
      userId: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          class: "text-link",
          href: "javascript:;",
          underline: false,
          onClick: ($event: any) => (copyValue(scope.row.userId))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.userId), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      unionid: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          class: "text-link",
          href: "javascript:;",
          underline: false,
          onClick: ($event: any) => (copyValue(scope.row.unionid))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.unionid), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      empId: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          class: "text-link",
          href: "javascript:;",
          underline: false,
          onClick: ($event: any) => (copyValue(scope.row.empId))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.empId), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})